import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css'],
})
export class NotFoundComponent {
  readonly anioActual = new Date().getFullYear();

  constructor(private readonly router: Router) {}

  irLogin(): void {
    this.router.navigate(['/login']);
  }

  cerrarPestana(): void {
    window.close();
  }
}